document.addEventListener('turbolinks:load', () => {
  if (!hasTouch()) document.body.classList.add('has-hover')
})

function hasTouch() {
  return 'ontouchstart' in document.documentElement
         || navigator.maxTouchPoints > 0
         || navigator.msMaxTouchPoints > 0;
}
